import { render, staticRenderFns } from "./ShopClient.vue?vue&type=template&id=4cd963d8&"
import script from "./ShopClient.vue?vue&type=script&lang=js&"
export * from "./ShopClient.vue?vue&type=script&lang=js&"
import style0 from "./ShopClient.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports